import { Device } from 'src/app/interfaces';

/**
 * Tenant identification headers per the HRS-2688 dual rule: a client app
 * sends `X-Cicerone-Client`; a distributor community app (its device config
 * exposes only `distributorID`) sends `X-Cicerone-Distributor`; if the
 * device config is not loaded yet, NO tenant header is sent (never a
 * literal "null") and the backend resolves the tenant from the request
 * origin (fallback chain Origin -> subdomain -> apps -> apps_distributors).
 *
 * Shared by every ticketing/wallet HTTP consumer (`ReservationTicketsService`,
 * `WalletTicketsService`). Pass `RestService.device()` read at request time.
 */
export function buildTenantHeaders(device: Device | null | undefined): Record<string, string> {
  if (device?.client) return { 'X-Cicerone-Client': device.client.toString() };
  if (device?.distributorID) return { 'X-Cicerone-Distributor': device.distributorID.toString() };
  return {};
}
